export const Numbers = {
  One: 1,
  Zero: 0,
};

export const DECIMAL_PLACES = 2;
